/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbqin
 * @LastEditTime: 2022-04-06 11:24:06
 */
import React, { Component } from 'react';
import classNames from 'classnames';
import { ViewModel, config as CONFIG, PubSub } from '@platform/api';

function TableWithAutoFocus(WrappedComponent) {
    return class WithAutoFocus extends Component {
        componentDidMount() {
            let { store, stores, id } = this.props._keyboardProps;
            if (stores) {
                // CardTable
                store = stores[id];
            }
            this.autoFocusToken = PubSub.subscribe('autoFocus', (msg, { data, next }) => {
                if (next === id) {
                    store.scrollIntoView(data);
                    requestAnimationFrame(() => {
                        // 等scrollIntoView起效果后再聚焦
                        let { rowKey, colKey } = data;
                        store.focusOnCell(rowKey, colKey);
                    });
                }
            });
        }

        componentWillUnmount() {
            this.autoFocusToken && PubSub.unsubscribe(this.autoFocusToken);
        }

        /**
         * @desc: 业务中存在新增行时先调用addRow后调用setStatus的方法导致焦点在table的第一个可编辑字段，
         *        而不在新增行的第一个可编辑字段上。
         * @resolve: 聚集时判断table是否包含当前活跃元素且活跃元素的tabIndex不等于-1，如果包含就不去执行autoFocus
         *           当前活跃元素可能是table里的操作列，全选功能里的input元素，如果是这些元素就依旧执行focus方法
         * @param el 需要聚焦的元素
         * @param activeEl 当前活跃的元素
         * @param tableId 区域Id
         * @param force true -> 强制执行
         * @return {boolean}
         */
        static judgeFocus(el, activeEl, tableId, force) {
            let tableEL = document.getElementById(tableId);
            if (el) {
                return activeEl.tabIndex !== -1 && tableEL && !tableEL.contains(activeEl) || force;
            }
        }

        render() {
            let { id, flex } = this.props;
            return (
                <div
                    id={`${CONFIG.hotKeyModuleIdPrefix}-${id}`}
                    className={classNames({
                        'flex-container': flex,
                        'table-with-auto-focus': true,
                    })}
                >
                    <WrappedComponent
                        {...this.props}
                    />
                </div>

            );
        }
    };
}

export default TableWithAutoFocus;
